<h1 mat-dialog-title> Confirmar cambios </h1>
<div mat-dialog-content style="padding-bottom: 0">
  <p class="generic-modal-body">
    Se han realizado algunas modificaciones. ¿Desea guardar los cambios?
  </p>
</div>
<div mat-dialog-actions class="generic-modal-actions">
  <button cButton variant="ghost" color="danger" mat-dialog-close="cancel">
    Cancelar
  </button>
  <button
    cButton
    variant="ghost"
    color="info"
    mat-dialog-close="continueEditing"
  >
    Seguir editando
  </button>
  <button
    cButton
    variant="ghost"
    color="primary"
    mat-dialog-close="send"
    cdkFocusInitial
  >
    Guardar
  </button>
</div>
